import { render } from "./ImplantableDeviceForm.vue?vue&type=template&id=6f8732d2"
import script from "./ImplantableDeviceForm.ts?vue&type=script&lang=js&external"
export * from "./ImplantableDeviceForm.ts?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__